import { render, staticRenderFns } from "./paydetail.vue?vue&type=template&id=bafcdbdc&scoped=true"
import script from "./paydetail.vue?vue&type=script&lang=ts"
export * from "./paydetail.vue?vue&type=script&lang=ts"
import style0 from "./paydetail.vue?vue&type=style&index=0&id=bafcdbdc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bafcdbdc",
  null
  
)

export default component.exports